export enum FlightTypeClassifications {
    NotSet = 0,
    Private = 1,
    Commercial = 2,
    All = 3,
}
